<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_spacer' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <!-- Configuration mode -->
    <div class="mode-card">
      <div class="mode-label">
        {{ 'configuration_mode' | translate }}
      </div>

      <ion-segment [value]="configType" (ionChange)="onModeChange($event)" mode="md">
        <ion-segment-button value="basic">
          <ion-label class="text-wrap">{{ 'HEADER_BASIC' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="advanced">
          <ion-label class="text-wrap">{{ 'HEADER_ADVANCED' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="manual">
          <ion-label class="text-wrap">{{ 'HEADER_MANUAL' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <ng-container *ngIf="this.configType=='basic'" class="contentDiv">
      <ion-list>
        <ng-container *ngFor="let obj of spacerData">
          <ion-item lines="none" class="cardDiv" (click)="selectBasicSpacerOpt(obj.id)"
            [ngClass]="obj['id'] == selectedSpacer ? 'selected' : ''" *ngIf="(obj['name'] | translate)?.trim()">
            <div class="image-container">
              <img [src]="obj.img" class="square-image" />
            </div>
            <div class="content-container">
              <h5 class="card-title" style="font-size: 16px !important;">{{obj.name | translate}}</h5>
              <p style="margin: 0; font-size: 14px !important;"> {{ 'HEADER_PSI_VALUE' | translate }}:{{ obj.psi | number:'1.3-3'}} W/mK
                <span class="sub-label" *ngIf="getSpacerSubLabel(obj.name)">
                  {{ getSpacerSubLabel(obj.name) }}
                </span>
              </p>
            </div>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-container>

    <ng-container *ngIf="this.configType=='advanced'" class="contentDiv">
      <div class="select-group">
        <ion-label class="select-label">{{'HEADER_SPACER' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedSpacer" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of spacerData" [value]="obj.id">
            {{obj.name | translate}}
          </ion-select-option>
        </ion-select>
      </div>
      <div class="select-group">
        <ion-label class="select-label">{{'HEADER_DESICCANT' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedDesiccant" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of desiccantData" [value]="obj.id">
            {{obj.name | translate}}
          </ion-select-option>
        </ion-select>
      </div>
      <div class="select-group">
        <ion-label class="select-label">{{'HEADER_SEALANT' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedSealant" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of sealantData" [value]="obj.id">
            {{obj.name | translate}}
          </ion-select-option>
        </ion-select>
      </div>
      <div class="select-group">
        <ion-label class="select-label">{{'HEADER_SEALANT_HEIGHT_PDF' | translate}}</ion-label>

        <ion-select [(ngModel)]="selectedSealantHeight" interface="popover" class="styled-select">
          <ion-select-option *ngFor="let obj of sealantHeightData" [value]="obj">
            {{obj}}
          </ion-select-option>
        </ion-select>
      </div>

      <p>{{'NOTE_GLAZING_EDGE' | translate}}</p>
    </ng-container>

    <ng-container *ngIf="this.configType=='manual'" class="contentDiv">

      <div class="form-container">
        <div class="select-group">
          <ion-label class="input-label">{{'HEADER_NAME' | translate}}</ion-label>
          <ion-input class="bordered-input" type="text" [(ngModel)]="eManSpacerName" name="eManSpacerName"
            (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="select-group">
          <ion-label class="input-label">{{'HEADER_PSI_GLASS_EDGE' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" [(ngModel)]="eManSpacerPsi" name="eManSpacerPsi"
            (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="select-group">
          <ion-label class="input-label">{{'HEADER_FRSI' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" [(ngModel)]="eManSpacerFrsi" name="eManSpacerFrsi"
            (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>
      </div>
      <p>{{'NOTE_FRSI_MANUAL' | translate}}</p>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>